export { ChatAlt2 as default } from './ChatAlt2';
